import VueTheMask from 'vue-the-mask'
import unmask from '../functions/unmask'

export default ({ Vue }) => {
  Vue.use(VueTheMask)
  Vue.prototype.$unmask = unmask
}
